export default __webpack_public_path__ + "static/MediaMainBannerMobile-7cab6e0275af3d5e9e94c37c306b4a17.webp";